import React, {FC} from "react";
import {App, Space} from "antd";
import ScoreInput from "./ScoreInput";
import {useAuth} from "../../config/AuthContext";
import {HasMatchStarted, IMatch} from "../../Interfaces/IMatch";
import {DomExt} from "../Team/ITeam";
import AxiosServices from "../../Services/axiosServices";
import axios from "axios";
import {IUserBets} from "../../Interfaces/IUserBets";
import {useGlobal} from "../../config/GlobalContext";
import {Paragraph} from "../Typography";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState} from "../../store";
import {fetchUserBets} from "../betsSlice";

interface Props {
    disable: boolean,
    testMatchStarted?: boolean,
    match: IMatch,
}

export interface ISaisie {
    dom?: number;
    ext?: number;
}

const SaisieScores: FC<Props> = (props: Props) => {

    const {authUser, isLoggedIn} = useAuth()
    const {currentCmpEdt} = useGlobal();
    const dispatch = useDispatch<AppDispatch>();
    const allBets = useSelector((state: RootState) => state.bets.userBets);
    const {message} = App.useApp();

    const handleInputChange = async (value: any, match: IMatch, etDomExt: DomExt) => {
        const team: string = (etDomExt === DomExt.DOM) ? match.Nom_Dom : match.Nom_Ext;
        const matchteam_idt: number = (etDomExt === DomExt.DOM) ? match.MatchTeam_Idt_Dom : match.MatchTeam_Idt_Ext;
        const otherMatchteam_idt: number = (etDomExt === DomExt.DOM) ? match.MatchTeam_Idt_Ext : match.MatchTeam_Idt_Dom;
        const otherAlreadyBet = allBets.some((b: IUserBets) => b.matchteam_idt === otherMatchteam_idt);
        const canFillOther = !otherAlreadyBet && value !== null && value !== undefined;
        console.log(`changed ${match.Idt} ${matchteam_idt} ${team} ${value}`);

        try {
            await AxiosServices.SaveUserBet(matchteam_idt, value);
            if (canFillOther) {
                await AxiosServices.SaveUserBet(otherMatchteam_idt, 0);
            }
            if (isLoggedIn && authUser?.username) {
                dispatch(fetchUserBets({competition: currentCmpEdt, usr: authUser.username}));
            }
            message.success(`Match n°${match.Num} — ${team} : ${value} enregistré.`, 1.5);
        } catch (e: unknown) {
            if (axios.isAxiosError(e)) {
                const status = e.response?.status;
                const serverMsg = (e.response?.data as any)?.message ?? e.response?.data ?? e.message;
                message.error(`Échec ${status ?? ''} pour ${team} : ${serverMsg ?? 'erreur inconnue'}`);
                console.error(e.message);
            } else {
                message.error(`Échec pour ${team} : ${(e as Error)?.message ?? 'erreur inconnue'}`);
                console.error(e);
            }
        }

    };
    const handleInputChangeDom = async (value: any) => {
        await handleInputChange(value, props.match, DomExt.DOM);
    };
    const handleInputChangeExt = async (value: any) => {
        await handleInputChange(value, props.match, DomExt.EXT);
    };

    const betDom = allBets.find((bet: IUserBets) => bet.matchteam_idt === props.match.MatchTeam_Idt_Dom);
    const betExt = allBets.find((bet: IUserBets) => bet.matchteam_idt === props.match.MatchTeam_Idt_Ext);
    const scoreDom = betDom?.score;
    const scoreExt = betExt?.score;
    // MySQL TINYINT(1) sometimes hits the JSON serializer as 0/1, sometimes as
    // boolean; normalise both sides truthy-style. Label only shows when BOTH
    // bets came from the dice (a manual override on either side flips back).
    const bothRandom = !!betDom && !!betExt && !!Number(betDom.random ?? 0) && !!Number(betExt.random ?? 0);

    const disable = props.disable || HasMatchStarted(props.match) || !isLoggedIn;

    return (
        <Space direction={"vertical"} size={1}>
            <Paragraph style={{width: "100px", textAlign: "center"}}>
                Ton pari{bothRandom ? ' (aléatoire)' : ''}
            </Paragraph>
            <Space>
                <ScoreInput score={scoreDom} disable={disable} callback={handleInputChangeDom}/>
                <ScoreInput score={scoreExt} disable={disable} callback={handleInputChangeExt}/>
            </Space>
        </Space>
    );
}
export default SaisieScores;
